import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query GetTaxForTenant($businessId: ID) {
    topupTaxForBusiness(businessId: $businessId) {
      name
      rate
    }
  }
`

export const topupTaxForBusinessKey = getQueryNames(query)[0]
export default query
